module.exports = __webpack_public_path__ + "img/phone3.d84896ce.jpg";